import { PAYMENTS_API_URL } from 'data/constants';

import { processSignedUrls } from '../processSignedUrls';

export async function uploadDepositClientFiles(
  depositId: string,
  formData: FormData,
) {
  const files: File[] = formData.getAll('file') as File[];
  const request = await Promise.all(
    files.map(async (file) => ({
      fileName: file.name,
      fileType: file.type,
    })),
  );

  const result = await fetch(
    `${PAYMENTS_API_URL}/public/payments/${depositId}/get_signed_urls`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    },
  );

  if (result.status > 399) {
    const responseBody = await result.text();
    throw new Error(`Failed to upload deposit files: ${responseBody}`);
  }

  const uploaded = await processSignedUrls(files, await result.json());

  if (!uploaded)
    throw new Error(
      `Failed to process files with signed urls: ${result.json()}`,
    );
}
